import { render, staticRenderFns } from "./threeDetail.vue?vue&type=template&id=6c7413cb&scoped=true"
import script from "./threeDetail.vue?vue&type=script&lang=js"
export * from "./threeDetail.vue?vue&type=script&lang=js"
import style0 from "./threeDetail.vue?vue&type=style&index=0&id=6c7413cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7413cb",
  null
  
)

export default component.exports